type FetchWithPreconnect = typeof fetch & {
  preconnect: (url: string | URL) => void
}

const runtimeFetch = fetch as Partial<FetchWithPreconnect>

function createAppFetch(defaultCredentials?: RequestCredentials): typeof fetch {
  const wrappedFetch = (input: Parameters<typeof fetch>[0], init?: Parameters<typeof fetch>[1]) => {
    if (!defaultCredentials) {
      return fetch(input, init)
    }

    return fetch(input, {
      ...init,
      credentials: init?.credentials ?? defaultCredentials,
    })
  }

  return Object.assign(wrappedFetch, {
    preconnect: runtimeFetch.preconnect ?? (() => {}),
  }) as typeof fetch
}

export const appFetch = createAppFetch()
export const appFetchWithCredentials = createAppFetch('include')
